export type PageNumber = number | 'ellipsis';

export const generatePageNumbers = (
  currentPage: number,
  pageCount: number,
  maxPagesDisplayed = 4,
): PageNumber[] => {
  const pages: PageNumber[] = [];
  const sidePages = Math.floor(maxPagesDisplayed / 2);

  if (pageCount <= maxPagesDisplayed) {
    for (let i = 1; i <= pageCount; i++) {
      pages.push(i);
    }
  } else if (currentPage <= sidePages + 1) {
    for (let i = 1; i <= maxPagesDisplayed - 1; i++) {
      pages.push(i);
    }
    pages.push('ellipsis');
    pages.push(pageCount);
  } else if (currentPage >= pageCount - sidePages) {
    pages.push(1);
    pages.push('ellipsis');
    for (let i = pageCount - (maxPagesDisplayed - 2); i <= pageCount; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);
    pages.push('ellipsis');
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      pages.push(i);
    }
    pages.push('ellipsis');
    pages.push(pageCount);
  }

  return pages;
};
